import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@ui/components/ui/loading-button';

import AnimateHeight from 'react-animate-height';

interface ExpandableContentProps {
  content?: string;
}

const ExpandableContent: React.FC<ExpandableContentProps> = ({ content }) => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLSpanElement>(null);
  const [isTextClamped, setShowTextClamped] = useState(true);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  // fix animation issue
  const approximatelyRowsHeight = contentRef.current ? 56 : 'auto';

  useEffect(() => {
    if (contentRef.current) {
      const { clientHeight, scrollHeight } = contentRef.current;

      setShowTextClamped(scrollHeight > clientHeight);

      if (typeof approximatelyRowsHeight === 'string') setShouldShowButton(scrollHeight > 0);
      else setShouldShowButton(scrollHeight > approximatelyRowsHeight);
    }
  }, [contentRef.current]);

  return (
    <>
      <AnimateHeight
        height={isTextClamped ? approximatelyRowsHeight : contentRef?.current?.scrollHeight || 'auto'}
        duration={300}
      >
        <span
          ref={contentRef}
          className={isTextClamped ? 'line-clamp-3 whitespace-pre-wrap' : 'block whitespace-pre-wrap'}
        >
          {content || ''}
        </span>
      </AnimateHeight>

      {contentRef.current && shouldShowButton && (
        <Button
          className="border-0 bg-transparent p-0 text-sm font-bold text-primary shadow-none hover:bg-transparent"
          onClick={() => setShowTextClamped(!isTextClamped)}
        >
          {isTextClamped ? t('showMore') : t('showLess')}
        </Button>
      )}
    </>
  );
};

export default ExpandableContent;
